"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _area = require("@/api/area");
var _merUserCategoryForArea = _interopRequireDefault(require("@/components/merUserCategoryForArea"));
var _TencentMap = _interopRequireDefault(require("@/components/TencentMap"));
var _settingMer = require("@/utils/settingMer");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 移除对 map.js 配置的依赖，直接使用 API 获取的缓存 key
var _default = exports.default = {
  name: 'AreaCreate',
  components: {
    merUserCategoryForArea: _merUserCategoryForArea.default,
    TencentMap: _TencentMap.default
  },
  data: function data() {
    var _this = this;
    return {
      currentTab: '1',
      tabList: [],
      routePrefix: (0, _settingMer.getRoutePrefix)(),
      circlePermiPrefix: "".concat((0, _settingMer.getAdminModule)(), ":circle"),
      loading: false,
      isViewMode: false,
      // 是否为查看模式
      lastRouteId: null,
      // 记录上次的路由ID，用于activated中判断是否需要重新初始化
      parentAreas: [],
      mapLocation: {},
      locationInfo: null,
      shouldRenderMap: false,
      // 控制地图是否渲染
      hasVisitedMapTab: false,
      // 记录是否访问过地图tab
      isMapInitialized: false,
      // 控制地图是否已初始化，避免重复初始化
      // 腾讯地点选择器基础地址（不含坐标）
      mapPickerBaseUrl: "https://apis.map.qq.com/tools/locpicker?type=1&key=".concat(localStorage.getItem('tencentMapKey') || '', "&referer=myapp"),
      hasShownInvalidCoordMsg: false,
      // 店铺选择相关
      merchantDialogVisible: false,
      bindingMerchant: false,
      // 绑定店铺加载状态
      merchantForm: {
        selectedMerchantId: '',
        selectedMerchants: []
      },
      formValidate: {
        id: null,
        // 店铺分组id，新建时为null，创建成功后设置
        merIds: [],
        pid: 0,
        name: '',
        range: '',
        addressSwitch: 2,
        // 区域开关，1为开启，2为关闭
        address: '',
        latitude: '',
        longitude: '',
        merchantCount: 0,
        merchantList: [] // 店铺分组关联的店铺列表
      },
      originalMerchantIds: [],
      // 记录页面初始化时的原始店铺ID列表
      ruleValidate: {
        pid: [{
          required: true,
          message: '请选择父级',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请填写店铺分组代理名称',
          trigger: 'blur'
        }],
        address: [{
          validator: function validator(rule, value, callback) {
            // 当区域开关关闭时(值为2)，店铺分组代理中心为非必填项
            if (_this.formValidate.addressSwitch === 2) {
              callback();
            } else {
              // 当区域开关开启时(值为1)，店铺分组代理中心为必填项
              if (!value || value.trim() === '') {
                callback(new Error('请填写店铺分组代理地址'));
              } else {
                callback();
              }
            }
          },
          trigger: 'blur'
        }],
        latitude: [{
          required: false,
          message: '请填写纬度',
          trigger: 'blur'
        }],
        longitude: [{
          required: false,
          message: '请填写经度',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    isEdit: function isEdit() {
      return !!this.$route.params.id;
    },
    backPath: function backPath() {
      return "".concat(this.routePrefix, "/area/index");
    },
    areaFormDisabled: function areaFormDisabled() {
      return this.isViewMode || !this.canSaveAreaInfo();
    },
    // 经纬度合法性校验，用于顶部提示，但不阻断地图渲染
    invalidCoord: function invalidCoord() {
      // 检查是否为空值或未定义，正确处理0值情况
      if (this.formValidate.latitude === '' || this.formValidate.latitude === null || this.formValidate.longitude === '' || this.formValidate.longitude === null || this.formValidate.latitude === undefined || this.formValidate.longitude === undefined) {
        return true;
      }
      var lat = parseFloat(this.formValidate.latitude);
      var lng = parseFloat(this.formValidate.longitude);
      var latOk = !isNaN(lat) && lat >= -90 && lat <= 90;
      var lngOk = !isNaN(lng) && lng >= -180 && lng <= 180;
      return !(latOk && lngOk);
    },
    // 通过 key 触发 iframe 重新挂载，避免旧的错误坐标影响交互
    mapPickerKey: function mapPickerKey() {
      // 确保经纬度为字符串格式，避免精度问题
      var lat = this.formValidate.latitude ? String(this.formValidate.latitude) : '0';
      var lng = this.formValidate.longitude ? String(this.formValidate.longitude) : '0';
      return this.invalidCoord ? "locpicker-invalid" : "locpicker-".concat(lat, "-").concat(lng, "-").concat(this.currentTab);
    },
    // 根据已有经纬度拼接 locpicker 的 coord 参数，编辑时让地图居中到已保存位置
    mapPickerUrl: function mapPickerUrl() {
      var base = this.mapPickerBaseUrl;
      // 经纬度不合法：不带 coord，让 locpicker 自动定位到当前
      if (this.invalidCoord) return base;
      // 只有在经纬度合法时才添加coord参数，正确处理0值情况
      if (!this.invalidCoord && this.formValidate.latitude !== '' && this.formValidate.latitude !== null && this.formValidate.latitude !== undefined && this.formValidate.longitude !== '' && this.formValidate.longitude !== null && this.formValidate.longitude !== undefined) {
        var latStr = String(this.formValidate.latitude).trim();
        var lngStr = String(this.formValidate.longitude).trim();
        return "".concat(base, "&coord=").concat(latStr, ",").concat(lngStr);
      }
      return base;
    },
    linkedMerchantIds: function linkedMerchantIds() {
      var _this2 = this;
      var merchantList = this.formValidate.merchantList || [];
      return merchantList.map(function (merchant) {
        return _this2.getMerchantUniqueId(merchant);
      }).filter(function (id) {
        return id;
      });
    },
    currentMerchantCount: function currentMerchantCount() {
      var merchantList = this.formValidate.merchantList || [];
      if (typeof this.formValidate.merchantCount === 'number') {
        return this.formValidate.merchantCount;
      }
      return merchantList.length;
    },
    mapCenter: function mapCenter() {
      if (this.invalidCoord) {
        return {
          lat: 39.908823,
          lng: 116.39747
        };
      }
      return {
        lat: parseFloat(this.formValidate.latitude),
        lng: parseFloat(this.formValidate.longitude)
      };
    }
  },
  watch: {
    // 监听区域开关变化，重新验证address字段
    'formValidate.addressSwitch': function formValidateAddressSwitch(newVal, oldVal) {
      var _this3 = this;
      if (newVal !== oldVal && this.$refs.formValidate) {
        // 当区域开关状态改变时，重新验证address字段
        this.$nextTick(function () {
          _this3.$refs.formValidate.validateField('address');
        });
      }
    },
    // 监听tab切换，当切换到第一个tab时初始化地图
    currentTab: function currentTab(newTab, oldTab) {
      var _this4 = this;
      // 新增店铺分组时，如果店铺分组ID为null或0，不允许切换到第二个tab
      // 但是如果是查看模式或编辑模式（有路由参数ID），则允许切换
      if (newTab === '2' && (!this.formValidate.id || this.formValidate.id === 0) && !this.$route.params.id) {
        // 只在创建模式时提示，详情模式不提示
        if (!this.isViewMode && !this.isEdit) {
          this.$message.warning('请先保存店铺分组');
        }
        this.$nextTick(function () {
          _this4.currentTab = oldTab || '1';
        });
        return;
      }
      if (newTab === '1' && !this.isMapInitialized && !this.isViewMode) {
        // 只有在地图未初始化且不是查看模式时才初始化
        this.initializeMap();
      }

      // 主动防御：切换到店铺Tab时强制刷新数据，确保数据一致性
      if (newTab === '2') {
        this.$nextTick(function () {
          _this4.proactiveRefreshMerchantData();
        });
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;
    this.initPage();
    // 监听腾讯地点选择器回传
    window.addEventListener('message', this.onMapPickerMessage, false);
    // 如果是编辑模式且经纬度不合法，延迟检查以确保数据加载完成
    this.$nextTick(function () {
      setTimeout(function () {
        try {
          if (_this5.isEdit && !_this5.isViewMode && _this5.invalidCoord && !_this5.hasShownInvalidCoordMsg) {
            _this5.hasShownInvalidCoordMsg = true;
            // this.$message.error('地图经纬度不合法，已为你定位到当前位置');
          }
        } catch (e) {
          // 忽略JSON解析错误
        }
      }, 500);
    });
  },
  activated: function activated() {
    // 每次激活页面时检查路由参数变化
    var currentRouteId = this.$route.params.id;
    var currentTab = this.$route.query.tab;

    // 只有当路由参数发生变化时才重新初始化
    if (this.lastRouteId !== currentRouteId) {
      this.lastRouteId = currentRouteId;
      this.initPage();
    } else if (currentTab && this.currentTab !== currentTab) {
      // 如果只是tab参数变化，只更新currentTab
      this.currentTab = currentTab;
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 离开页面时重置表单数据
    this.resetForm();
    next();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.onMapPickerMessage, false);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    hasCirclePermi: function hasCirclePermi(action) {
      return this.checkPermi(["".concat(this.circlePermiPrefix, ":").concat(action)]);
    },
    canSaveAreaInfo: function canSaveAreaInfo() {
      return this.isEdit ? this.hasCirclePermi('update') : this.hasCirclePermi('save');
    },
    canBindCircleMerchant: function canBindCircleMerchant() {
      return this.hasCirclePermi('bind') && this.hasCirclePermi('merchant');
    },
    // 获取当前地图API Key
    getCurrentMapKey: function getCurrentMapKey() {
      return localStorage.getItem('tencentMapKey') || '未配置';
    },
    // 初始化页面
    initPage: function initPage() {
      var _this6 = this;
      // 检查是否为查看模式
      this.isViewMode = this.$route.query.mode === 'view';

      // 设置tab标题
      this.tabList = [{
        value: '1',
        title: this.isViewMode ? '查看店铺分组' : '店铺分组维护'
      }, {
        value: '2',
        title: '归属店铺'
      }];

      // 先检查路由查询参数中的tab参数
      var tabParam = this.$route.query.tab;
      this.resetForm();

      // 在resetForm之后重新设置tab参数，避免被重置
      if (tabParam) {
        this.currentTab = tabParam;
      }

      // 先获取父级店铺分组数据，然后再获取店铺分组信息
      this.getParentAreas().then(function () {
        // 如果是编辑模式，获取店铺分组信息
        if (_this6.$route.params.id) {
          _this6.getAreaInfo(_this6.$route.params.id);
        } else {
          // 新增模式，检查是否有父级ID参数
          var parentId = _this6.$route.query.parentId;
          if (parentId) {
            _this6.formValidate.pid = parseInt(parentId);
          } else {
            _this6.formValidate.pid = 0; // 顶级店铺分组
          }
        }
      }).catch(function (error) {
        console.error('获取父级店铺分组失败:', error);
        // 即使获取父级店铺分组失败，也要继续处理编辑模式
        if (_this6.$route.params.id) {
          _this6.getAreaInfo(_this6.$route.params.id);
        }
      });

      // 如果当前在第一个tab或者没有指定tab，且不是查看模式，自动初始化地图
      if ((!tabParam || tabParam === '1') && !this.isViewMode && !this.isMapInitialized) {
        // 延迟初始化地图，确保DOM已渲染
        this.$nextTick(function () {
          setTimeout(function () {
            _this6.initializeMap();
          }, 100);
        });
      }
    },
    // 重置表单数据
    resetForm: function resetForm() {
      this.formValidate = {
        id: null,
        // 店铺分组id，新建时为null，创建成功后设置
        merIds: [],
        pid: 0,
        name: '',
        range: '',
        address: '',
        latitude: '',
        longitude: '',
        merchantCount: 0,
        merchantList: [],
        addressSwitch: 2
      };
      this.originalMerchantIds = []; // 重置原始店铺ID列表
      this.currentTab = '1';
      this.loading = false;
      // 重置店铺选择相关数据
      this.merchantDialogVisible = false;
      this.merchantForm.selectedMerchantId = '';
      this.merchantForm.selectedMerchants = [];
      this.bindingMerchant = false;
      // 重置地图渲染状态
      this.shouldRenderMap = false;
      this.hasVisitedMapTab = false;
      this.isMapInitialized = false;
      this.locationInfo = null;
      // 清除表单验证
      if (this.$refs.formValidate) {
        this.$refs.formValidate.clearValidate();
      }
    },
    // 腾讯地点选择器回传处理
    onMapPickerMessage: function onMapPickerMessage(event) {
      if (!event || !event.data || event.data.module !== 'locationPicker') return;
      var _event$data = event.data,
        latlng = _event$data.latlng,
        poiaddress = _event$data.poiaddress,
        poiname = _event$data.poiname;
      if (latlng && typeof latlng.lat !== 'undefined' && typeof latlng.lng !== 'undefined') {
        // 确保经纬度保持字符串格式
        this.formValidate.latitude = String(latlng.lat);
        this.formValidate.longitude = String(latlng.lng);
      }
      var address = poiname ? "".concat(poiname, " ").concat(poiaddress || '').trim() : poiaddress || '';
      if (address) {
        this.formValidate.address = address;
      }
      // 日志便于排查：收到回传后可确认表单字段
      try {
        console.log('[locpicker] selected:', {
          lat: this.formValidate.latitude,
          lng: this.formValidate.longitude,
          address: this.formValidate.address
        });
      } catch (e) {
        // 忽略postMessage错误
      }
    },
    // 打开店铺选择弹窗
    openMerchantDialog: function openMerchantDialog() {
      var _this7 = this;
      if (!this.canBindCircleMerchant()) return;
      this.merchantForm.selectedMerchantId = null;
      this.merchantForm.selectedMerchants = [];
      this.merchantDialogVisible = true;
      // 每次打开弹窗时刷新店铺选择组件的数据，获取最新的可选店铺列表
      this.$nextTick(function () {
        if (_this7.$refs.merchantSelector) {
          _this7.$refs.merchantSelector.resetSelection();
          _this7.$refs.merchantSelector.refreshAreaMerchantData();
        }
      });
    },
    // 关闭店铺选择弹窗
    closeMerchantDialog: function closeMerchantDialog() {
      this.merchantDialogVisible = false;
      this.merchantForm.selectedMerchantId = null;
      this.merchantForm.selectedMerchants = [];
      this.bindingMerchant = false;
    },
    resetMerchantDialogSelection: function resetMerchantDialogSelection() {
      var _this8 = this;
      this.merchantForm.selectedMerchantId = null;
      this.merchantForm.selectedMerchants = [];
      this.bindingMerchant = false;
      this.$nextTick(function () {
        if (_this8.$refs.merchantSelector) {
          _this8.$refs.merchantSelector.resetSelection();
        }
      });
    },
    // 获取店铺ID
    getMerId: function getMerId(merId) {
      var merchants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      // 确保ID类型一致，统一转为数字类型
      if (Array.isArray(merId)) {
        this.merchantForm.selectedMerchantId = merId.map(function (id) {
          return Number(id);
        });
      } else if (merId !== null && merId !== undefined) {
        this.merchantForm.selectedMerchantId = Number(merId);
      } else {
        this.merchantForm.selectedMerchantId = null;
      }
      this.merchantForm.selectedMerchants = Array.isArray(merchants) ? merchants : [];
    },
    // 确认选择店铺
    confirmMerchantSelection: function () {
      var _confirmMerchantSelection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var selectedIds, selectedMerchants;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              selectedIds = Array.isArray(this.merchantForm.selectedMerchantId) ? this.merchantForm.selectedMerchantId : this.merchantForm.selectedMerchantId ? [this.merchantForm.selectedMerchantId] : [];
              if (selectedIds.length) {
                _context.n = 1;
                break;
              }
              this.$message.warning('请选择店铺');
              return _context.a(2);
            case 1:
              try {
                // 使用选择组件返回的完整店铺数据
                selectedMerchants = this.getSelectedMerchantsData(selectedIds); // 只进行本地添加，不调用任何API
                this.addMerchantsWithData(selectedMerchants);
                // 移除成功提示，只在最终保存时提示
                this.closeMerchantDialog();
                this.resetMerchantDialogSelection();
              } catch (error) {
                console.error('添加店铺失败:', error);
                this.$message.error('添加店铺失败，请重试');
                this.resetMerchantDialogSelection();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function confirmMerchantSelection() {
        return _confirmMerchantSelection.apply(this, arguments);
      }
      return confirmMerchantSelection;
    }(),
    // 根据店铺ID获取店铺详情数据
    getSelectedMerchantsData: function getSelectedMerchantsData(selectedIds) {
      var ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
      var selectedMap = new Map(this.merchantForm.selectedMerchants.map(function (item) {
        return [Number(item.id), item];
      }));
      return ids.map(function (id) {
        var merchantDetail = selectedMap.get(Number(id)) || {};
        return {
          id: Number(id),
          name: merchantDetail.name || '未知店铺',
          realName: merchantDetail.realName || '',
          phone: merchantDetail.phone || '',
          merId: Number(id)
        };
      });
    },
    // 添加店铺完整数据到本地列表
    addMerchantsWithData: function addMerchantsWithData(merchantsData) {
      var _this9 = this;
      this.initMerchantData();
      var merchantList = this.formValidate.merchantList || [];
      merchantsData.forEach(function (merchant) {
        // 检查是否已存在
        var exists = merchantList.some(function (m) {
          return _this9.getMerchantUniqueId(m) === merchant.id;
        });
        if (!exists) {
          _this9.formValidate.merchantList.push(merchant);
        }
      });
      this.syncMerchantData();
    },
    // 本地添加店铺
    addMerchantsLocally: function addMerchantsLocally(selectedMerchantIds) {
      var _this0 = this;
      this.initMerchantData();
      var idsToAdd = Array.isArray(selectedMerchantIds) ? selectedMerchantIds : [selectedMerchantIds];
      var merchantList = this.formValidate.merchantList || [];
      idsToAdd.forEach(function (merId) {
        var numMerId = Number(merId);
        // 检查是否已存在
        var exists = merchantList.some(function (m) {
          return _this0.getMerchantUniqueId(m) === numMerId;
        });
        if (!exists) {
          _this0.formValidate.merchantList.push({
            id: numMerId,
            name: '店铺' + numMerId,
            // 临时名称，实际应通过API获取
            merId: numMerId
          });
        }
      });
      this.syncMerchantData();
    },
    // 绑定店铺到店铺分组
    bindMerchantsToArea: function () {
      var _bindMerchantsToArea = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(areaId, selectedMerchantIds) {
        var response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.bindingMerchant = true;
              _context2.n = 1;
              return (0, _area.areaBindMerchantApi)({
                id: areaId,
                merchantIds: selectedMerchantIds
              });
            case 1:
              response = _context2.v;
              if (response) {
                // 移除中间提示，只在最终保存时显示成功提示
                // 店铺绑定成功后主动刷新数据，确保表格显示最新状态
                this.proactiveRefreshMerchantData();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.error('绑定店铺失败:', _t);
              this.$message.error('绑定店铺失败: ' + (_t.message || '未知错误'));
              throw _t;
            case 3:
              _context2.p = 3;
              this.bindingMerchant = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2, 3, 4]]);
      }));
      function bindMerchantsToArea(_x, _x2) {
        return _bindMerchantsToArea.apply(this, arguments);
      }
      return bindMerchantsToArea;
    }(),
    // 获取店铺的唯一标识ID
    getMerchantUniqueId: function getMerchantUniqueId(merchant) {
      return Number(merchant.id || merchant.merId || merchant.merchantId);
    },
    // 获取表格数据 - 主动防御，确保数据准确性
    getTableData: function getTableData() {
      var _this1 = this;
      // 每次获取表格数据时都进行检查和同步
      var merchantList = this.formValidate.merchantList || [];

      // 静默检查数据一致性（只在开发模式下打印）
      if (process.env.NODE_ENV === 'development' && merchantList.length > 0) {
        var uniqueIds = new Set();
        var duplicates = [];
        merchantList.forEach(function (merchant) {
          var id = _this1.getMerchantUniqueId(merchant);
          if (uniqueIds.has(id)) {
            duplicates.push(id);
          } else {
            uniqueIds.add(id);
          }
        });
        if (duplicates.length > 0) {
          console.warn('发现重复的店铺ID:', duplicates);
        }
      }
      return merchantList;
    },
    // 初始化店铺数据结构
    initMerchantData: function initMerchantData() {
      if (!this.formValidate.merchantList) {
        this.formValidate.merchantList = [];
      }
      if (!this.formValidate.merIds) {
        this.formValidate.merIds = [];
      }
    },
    // 同步店铺ID数组与店铺列表
    syncMerchantData: function syncMerchantData() {
      var _this10 = this;
      this.initMerchantData();
      var merchantList = this.formValidate.merchantList || [];
      this.formValidate.merIds = merchantList.map(function (m) {
        return _this10.getMerchantUniqueId(m);
      });
      this.formValidate.merchantCount = merchantList.length;
    },
    // 处理删除店铺操作 - 增强版本，确保获取正确的ID
    handleRemoveMerchant: function handleRemoveMerchant(row, index) {
      this.formValidate.merchantList.splice(index, 1);
      this.syncMerchantData();
    },
    // 移除店铺
    removeMerchant: function removeMerchant(merchantId) {
      var _this11 = this;
      var areaId = this.$route.params.id || this.formValidate.id;
      var numMerchantId = Number(merchantId);

      // 判断该店铺是否为后台数据还是前端临时添加
      var isFromBackend = this.isMerchantFromBackend(numMerchantId);
      this.$confirm('确定要移除该店铺吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (isFromBackend && _this11.isEdit && areaId) {
          // 来自后台的数据，调用解绑API（不显示提示，等最终保存时统一提示）
          _this11.removeMerchantFromBackendSilent(areaId, numMerchantId);
        } else {
          // 前端临时添加的数据，只从本地删除（不显示提示）
          _this11.removeMerchantLocallySilent(numMerchantId);
        }
      });
    },
    // 判断店铺是否来自后台数据
    isMerchantFromBackend: function isMerchantFromBackend(merchantId) {
      var _this$formValidate$me,
        _this12 = this;
      // 需要一个标识来区分店铺来源
      // 方案1: 检查店铺是否在页面初始化时就存在（即来自getAreaInfo接口）
      // 方案2: 给临时添加的店铺添加特殊标记

      // 如果不是编辑模式，所有店铺都是前端添加的
      if (!this.isEdit) {
        return false;
      }

      // 在编辑模式下，需要检查店铺是否在初始数据中
      // 这里我们可以通过检查店铺对象是否有完整的后台字段来判断
      var merchant = (_this$formValidate$me = this.formValidate.merchantList) === null || _this$formValidate$me === void 0 ? void 0 : _this$formValidate$me.find(function (m) {
        return _this12.getMerchantUniqueId(m) === merchantId;
      });
      if (!merchant) {
        return false;
      }

      // 如果店铺有完整的后台字段（如createTime等），说明来自后台
      // 或者我们可以检查店铺名是否是临时格式"店铺123"
      var isTemporaryName = merchant.name && merchant.name.startsWith('店铺') && /^店铺\d+$/.test(merchant.name);

      // 如果是临时名称格式，说明是前端添加的；否则来自后台
      return !isTemporaryName;
    },
    // 从后台删除店铺（调用解绑API）
    removeMerchantFromBackend: function () {
      var _removeMerchantFromBackend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(areaId, merchantId) {
        var data, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              data = {
                id: areaId,
                merchantIds: [merchantId]
              };
              _context3.n = 1;
              return (0, _area.areaRemoveMerchantApi)(data);
            case 1:
              this.$message.success('店铺解绑成功');

              // API调用成功后，从本地列表中移除
              this.removeMerchantLocally(merchantId);

              // 重新获取最新数据确保同步
              this.refreshCurrentData();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              this.$message.error('店铺解绑失败');
              console.error('店铺解绑失败:', _t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function removeMerchantFromBackend(_x3, _x4) {
        return _removeMerchantFromBackend.apply(this, arguments);
      }
      return removeMerchantFromBackend;
    }(),
    // 静默删除后台店铺（不显示提示）
    removeMerchantFromBackendSilent: function () {
      var _removeMerchantFromBackendSilent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(areaId, merchantId) {
        var data, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              data = {
                id: areaId,
                merchantIds: [merchantId]
              };
              _context4.n = 1;
              return (0, _area.areaRemoveMerchantApi)(data);
            case 1:
              // 不显示成功提示，API调用成功后从本地列表中移除
              this.removeMerchantLocallySilent(merchantId);

              // 重新获取最新数据确保同步
              this.refreshCurrentData();
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              this.$message.error('店铺解绑失败');
              console.error('店铺解绑失败:', _t3);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function removeMerchantFromBackendSilent(_x5, _x6) {
        return _removeMerchantFromBackendSilent.apply(this, arguments);
      }
      return removeMerchantFromBackendSilent;
    }(),
    // 静默删除本地店铺（不显示提示）
    removeMerchantLocallySilent: function removeMerchantLocallySilent(merchantId) {
      var _this13 = this;
      this.initMerchantData();

      // 确保merchantList存在
      var merchantList = this.formValidate.merchantList || [];
      var beforeLength = merchantList.length;

      // 删除店铺列表中的项目
      this.formValidate.merchantList = merchantList.filter(function (merchant) {
        return _this13.getMerchantUniqueId(merchant) !== merchantId;
      });

      // 同步更新merIds
      this.syncMerchantData();
      var afterLength = (this.formValidate.merchantList || []).length;
      if (beforeLength === afterLength) {
        console.warn('未找到要删除的店铺，ID:', merchantId);
      }

      // 统一使用数据刷新机制，确保数据一致性
      this.refreshCurrentData();
    },
    // 本地删除店铺
    removeMerchantLocally: function removeMerchantLocally(merchantId) {
      var _this14 = this;
      this.initMerchantData();

      // 确保merchantList存在
      var merchantList = this.formValidate.merchantList || [];
      var beforeLength = merchantList.length;

      // 删除店铺列表中的项目
      this.formValidate.merchantList = merchantList.filter(function (merchant) {
        return _this14.getMerchantUniqueId(merchant) !== merchantId;
      });

      // 同步更新merIds
      this.syncMerchantData();
      var afterLength = (this.formValidate.merchantList || []).length;
      if (beforeLength === afterLength) {
        this.$message.warning('未找到要删除的店铺');
      } else {
        this.$message.success('店铺删除成功');
      }

      // 统一使用数据刷新机制，确保数据一致性
      this.refreshCurrentData();
    },
    // 刷新店铺选择组件
    refreshMerchantSelector: function refreshMerchantSelector() {
      var _this15 = this;
      this.$nextTick(function () {
        if (_this15.$refs.merchantSelector) {
          // 确保merIds存在且不为空
          var merIds = _this15.formValidate.merIds || [];
          _this15.$refs.merchantSelector.merIds = merIds.length > 0 ? merIds : null;
          _this15.$refs.merchantSelector.refreshAreaMerchantData();
        }
      });
    },
    // 强制刷新表格数据
    forceRefreshTable: function forceRefreshTable() {
      var _this16 = this;
      this.$nextTick(function () {
        // 通过重新设置数组引用来触发表格刷新
        if (_this16.formValidate.merchantList) {
          _this16.formValidate.merchantList = _toConsumableArray(_this16.formValidate.merchantList);
        }
      });
    },
    // 刷新当前页面数据 - 统一的数据刷新入口
    refreshCurrentData: function refreshCurrentData() {
      var _this17 = this;
      var areaId = this.$route.params.id || this.formValidate.id;
      if (this.isEdit && areaId) {
        // 编辑模式：重新获取服务器数据
        this.getMerchantList(areaId).then(function () {
          _this17.refreshMerchantSelector();
          _this17.forceRefreshTable();
        }).catch(function (error) {
          // 即使刷新失败，也要尝试刷新UI组件
          _this17.refreshMerchantSelector();
          _this17.forceRefreshTable();
        });
      } else {
        // 新增模式：同步本地数据并刷新UI
        this.syncMerchantData();
        this.refreshMerchantSelector();
        this.forceRefreshTable();
      }
    },
    // 主动刷新店铺数据 - 防患于未然
    proactiveRefreshMerchantData: function proactiveRefreshMerchantData() {
      var _this18 = this;
      var areaId = this.$route.params.id || this.formValidate.id;
      if (!areaId) {
        console.log('新增模式，无需从服务器获取数据');
        return;
      }
      if (this.isEdit) {
        // 静默刷新，不显示loading，用户无感知
        this.getMerchantList(areaId).then(function () {
          _this18.forceRefreshTable();
        }).catch(function (error) {
          console.warn('主动刷新店铺数据失败，继续使用当前数据:', error);
        });
      } else {
        // 新增模式下确保数据同步
        this.syncMerchantData();
        this.forceRefreshTable();
      }
    },
    // 保存店铺关联
    saveMerchants: function () {
      var _saveMerchants = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var areaId, ids, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (this.canBindCircleMerchant()) {
                _context5.n = 1;
                break;
              }
              this.$message.warning('暂无归属店铺操作权限');
              return _context5.a(2);
            case 1:
              areaId = this.$route.params.id || this.formValidate.id;
              if (areaId) {
                _context5.n = 2;
                break;
              }
              this.$message.error('请先保存店铺分组信息');
              return _context5.a(2);
            case 2:
              _context5.p = 2;
              this.loading = true;
              ids = this.formValidate.merchantList.map(function (item) {
                return item.id;
              });
              _context5.n = 3;
              return this.bindMerchantsToArea(areaId, ids);
            case 3:
              this.$message.success('店铺关联更新成功');
              this.$router.push(this.backPath);
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t4 = _context5.v;
              console.error('保存店铺关联失败:', _t4);
              // this.$message.error('保存失败: ' + (error.message || '未知错误'))
            case 5:
              _context5.p = 5;
              this.loading = false;
              return _context5.f(5);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 4, 5, 6]]);
      }));
      function saveMerchants() {
        return _saveMerchants.apply(this, arguments);
      }
      return saveMerchants;
    }(),
    // 下一步/确认
    saveArea: function saveArea(tab) {
      var _this19 = this;
      if (!this.canSaveAreaInfo()) {
        this.$message.warning('暂无店铺分组保存权限');
        return;
      }
      // 防止重复提交
      if (this.loading) {
        return;
      }

      // 验证第一个Tab的表单
      var fieldsToValidate = ['name', 'addressSwitch'];
      // 如果开关开启 验证 address
      if (this.formValidate.addressSwitch === 1) {
        fieldsToValidate.push('address');
      }

      // 使用validate方法验证指定字段
      var validationPromises = fieldsToValidate.map(function (field) {
        return new Promise(function (resolve) {
          _this19.$refs.formValidate.validateField(field, function (errorMessage) {
            resolve(!errorMessage); // 如果没有错误消息，则验证通过
          });
        });
      });
      Promise.all(validationPromises).then(function (results) {
        var allValid = results.every(function (result) {
          return result;
        });
        if (allValid) {
          // 表单验证通过，调用相应的API保存店铺分组信息
          _this19.loading = true;

          // 构建提交数据，只保留后端接收的店铺分组字段
          var submitData = {
            address: _this19.formValidate.address,
            latitude: _this19.formValidate.latitude,
            longitude: _this19.formValidate.longitude,
            name: _this19.formValidate.name,
            addressSwitch: _this19.formValidate.addressSwitch
          };

          // 如果有父级ID，则添加到提交数据中
          if (_this19.formValidate.pid) {
            submitData.pid = _this19.formValidate.pid;
          }

          // 如果是编辑模式，添加ID字段
          if (_this19.isEdit) {
            submitData.id = _this19.$route.params.id;
          }

          // 根据模式选择API
          var api = _this19.isEdit ? _area.areaUpdateApi : _area.areaSaveApi;
          var successMessage = _this19.isEdit ? '店铺分组更新成功' : '店铺分组创建成功';
          api(submitData).then(function (res) {
            _this19.loading = false;
            _this19.$message.success(successMessage);

            // 无论新增还是编辑，都刷新当前页面数据
            if (_this19.$route.params.id) {
              _this19.getAreaInfo(_this19.$route.params.id);
            } else {
              // 新增模式下，获取刚创建的店铺分组信息并更新路由
              var newAreaId = res;
              if (newAreaId) {
                // 设置当前创建的店铺分组id到表单数据中，供绑定店铺时使用
                _this19.formValidate.id = newAreaId;
                // 更新路由参数，设置当前创建的店铺分组id
                _this19.$router.replace(_this19.areaPath("/area/create/".concat(newAreaId)));
                _this19.getAreaInfo(newAreaId);
              }
            }

            // 成功保存后自动跳转到第二个tab（归属店铺）
            _this19.currentTab = '2';
          }).catch(function (error) {
            _this19.loading = false;
            _this19.$message.error('保存失败，请重试');
            console.error('保存店铺分组信息失败:', error);
          });
        } else {
          _this19.$message.error('请完善店铺分组信息');
        }
      }).catch(function (error) {
        console.error('表单验证出错:', error);
        _this19.$message.error('表单验证失败');
      });
    },
    // 保存表单
    saveForm: function saveForm() {
      var _this20 = this;
      if (!this.canSaveAreaInfo()) {
        return Promise.reject(new Error('暂无店铺分组保存权限'));
      }
      // 防止重复提交
      if (this.loading) {
        return Promise.reject(new Error('正在提交中，请勿重复操作'));
      }
      return new Promise(function (resolve, reject) {
        _this20.$refs.formValidate.validate(function (valid) {
          if (valid) {
            _this20.loading = true;

            // 构建提交数据，只保留后端接收的店铺分组字段
            var submitData = {
              address: _this20.formValidate.address,
              latitude: _this20.formValidate.latitude,
              longitude: _this20.formValidate.longitude,
              name: _this20.formValidate.name,
              addressSwitch: _this20.formValidate.addressSwitch
            };
            // 如果有父级ID，则添加到提交数据中
            if (_this20.formValidate.pid) {
              submitData.pid = _this20.formValidate.pid;
            }
            var api = _this20.isEdit ? _area.areaUpdateApi : _area.areaSaveApi;
            api(submitData).then(function (res) {
              _this20.loading = false;
              _this20.$message.success('操作成功');
              // 如果是新增，需要更新路由参数以获取新的店铺分组ID
              var newAreaId = res.data && res.data.id || res.id;
              if (!_this20.isEdit && newAreaId) {
                // 设置当前创建的店铺分组id到表单数据中，供绑定店铺时使用
                _this20.formValidate.id = newAreaId;
                _this20.$router.replace(_this20.areaPath("/area/create/".concat(newAreaId)));
                // 获取新创建店铺分组的详情信息
                _this20.getAreaInfo(newAreaId);
              }
              resolve(res);
            }).catch(function (error) {
              _this20.loading = false;
              _this20.$message.error('操作失败');
              reject(error);
            });
          } else {
            _this20.$message.error('请完善表单信息');
            reject(new Error('表单验证失败'));
          }
        });
      });
    },
    areaPath: function areaPath(path) {
      return "".concat(this.routePrefix).concat(path);
    },
    // 扁平化树形数据
    flattenTreeData: function flattenTreeData(treeData) {
      var _this21 = this;
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var result = [];
      if (Array.isArray(treeData)) {
        treeData.forEach(function (item) {
          // 根据层级添加不同的前缀来区分不同层级
          var prefix = '';
          var isDisabled = false;
          if (level === 1) {
            // 二级：添加短横线
            prefix = '├─ ';
          } else if (level === 2) {
            // 三级：添加双短横线
            prefix = '├── ';
            isDisabled = true;
          } else if (level > 2) {
            // 四级及以上：添加更多横线
            prefix = '├' + '─'.repeat(level) + ' ';
            isDisabled = true;
          }
          result.push({
            id: item.id,
            name: level > 0 ? prefix + item.name : item.name,
            pid: item.pid,
            disabled: isDisabled
          });
          // 如果有子节点，递归处理
          if (item.childList && item.childList.length > 0) {
            result = result.concat(_this21.flattenTreeData(item.childList, level + 1));
          }
        });
      }
      return result;
    },
    // 获取父级店铺分组列表
    getParentAreas: function getParentAreas() {
      var _this22 = this;
      // 添加分页参数
      var params = {
        page: 1,
        limit: 999 // 设置一个较大的值以获取更多数据
      };
      return (0, _area.areaListTreeApi)(params).then(function (res) {
        // 从API响应中提取list数据
        var areaList = res.data && res.data.list ? res.data.list : res.list || res || [];
        // 将树形数据扁平化处理
        _this22.parentAreas = _this22.flattenTreeData(areaList);
        return res;
      }).catch(function (error) {
        console.error('获取父级店铺分组失败:', error);
        _this22.parentAreas = [];
        throw error;
      });
    },
    // 获取店铺分组信息（编辑时使用）
    getAreaInfo: function getAreaInfo(id) {
      var _this23 = this;
      // 如果已经在加载中，直接返回
      if (this.loading) {
        return Promise.resolve();
      }
      this.loading = true;
      return new Promise(function (resolve, reject) {
        (0, _area.areaInfoApi)(id).then(function (res) {
          // 在这个项目中，res就直接是data，添加数据验证
          if (!res) {
            _this23.loading = false;
            reject(new Error('获取店铺分组信息失败：数据为空'));
            return;
          }
          _this23.formValidate = {
            id: res.id || id,
            // 设置店铺分组id
            pid: res.pid !== undefined ? res.pid : '',
            name: res.name || '',
            range: res.range || '',
            address: res.address || '',
            latitude: res.latitude ? String(res.latitude) : '',
            longitude: res.longitude ? String(res.longitude) : '',
            merchantCount: typeof res.merchantCount === 'number' ? res.merchantCount : (res.merchantList || []).length,
            merchantList: res.merchantList || [],
            addressSwitch: res.addressSwitch || 2
          };

          // 记录原始店铺ID列表，用于区分新增店铺
          _this23.originalMerchantIds = (res.merchantList || []).map(function (m) {
            return _this23.getMerchantUniqueId(m);
          });
          // 如果有地址信息，显示位置信息并初始化地图
          if (res.latitude && res.longitude && res.address) {
            _this23.locationInfo = {
              lat: res.latitude,
              lng: res.longitude,
              addr: res.address,
              accuracy: 0
            };

            // 设置地图位置数据，v-if确保只有在第一个tab时才会渲染地图组件
            _this23.mapLocation = {
              lat: res.latitude ? String(res.latitude) : '',
              lng: res.longitude ? String(res.longitude) : '',
              address: res.address
            };
          } else {
            // 确保即使没有地址信息，mapLocation也有默认值
            _this23.locationInfo = null;
            _this23.mapLocation = {};
          }

          // 店铺列表数据已通过areaInfoApi获取并赋值到formValidate.merchantList

          _this23.loading = false;
          resolve(res);
        }).catch(function (err) {
          _this23.loading = false;
          _this23.$message.error('获取店铺分组信息失败');
          reject(err);
        });
      });
    },
    // 获取店铺分组关联的店铺列表
    getMerchantList: function getMerchantList(areaId) {
      var _this24 = this;
      if (!areaId) {
        return Promise.resolve();
      }

      // 重新获取店铺分组信息，包括店铺列表
      return this.getAreaInfo(areaId).catch(function (error) {
        console.error('重新获取店铺分组信息失败:', error);
        // 确保即使失败也有默认的空数组
        if (!_this24.formValidate.merchantList) {
          _this24.formValidate.merchantList = [];
        }
        // 即使失败也要返回resolved状态，避免阻塞后续操作
        return Promise.resolve();
      });
    },
    // 地图位置变化事件处理
    onLocationChange: function onLocationChange(locationData) {
      var _this25 = this;
      // 更新表单字段
      this.formValidate.latitude = String(locationData.lat);
      this.formValidate.longitude = String(locationData.lng);
      if (locationData.address) {
        this.formValidate.address = locationData.address;
      }

      // 更新地图位置数据
      this.mapLocation = locationData.locationInfo;
      if (this.$refs.formValidate) {
        this.$nextTick(function () {
          _this25.$refs.formValidate.validateField('address');
        });
      }
    },
    // 地图准备就绪事件处理
    onMapReady: function onMapReady(map) {
      console.log('地图准备就绪:', map);
    },
    // 地图错误事件处理
    onMapError: function onMapError(error) {
      var _this26 = this;
      console.error('地图错误:', error);

      // 检查是否是"far <= 0"错误
      if (error.message && error.message.includes('far')) {
        console.warn('检测到地图距离计算错误，尝试重新初始化地图');
        this.$message.warning('地图初始化异常，正在重新加载...');

        // 延迟重新初始化地图
        setTimeout(function () {
          if (_this26.$refs.tencentMap && _this26.$refs.tencentMap.reinitializeMap) {
            _this26.$refs.tencentMap.reinitializeMap();
          }
        }, 1000);
      } else {
        var errorMessage = error && error.message ? error.message : error || '未知错误';
        this.$message.error('地图加载失败：' + errorMessage);
      }
    },
    // 显示坐标信息
    showCoordinates: function showCoordinates() {
      var lat = this.formValidate.latitude;
      var lng = this.formValidate.longitude;
      var address = this.formValidate.addressDetail || '地址信息获取中...';
      this.$alert("<div style=\"text-align: left;\">\n          <p><strong>\u7EAC\u5EA6\uFF1A</strong>".concat(lat, "</p>\n          <p><strong>\u7ECF\u5EA6\uFF1A</strong>").concat(lng, "</p>\n          <p><strong>\u5730\u5740\uFF1A</strong>").concat(address, "</p>\n        </div>"), '位置信息', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定'
      });
    },
    // 初始化地图
    initializeMap: function initializeMap() {
      var _this27 = this;
      // 防止重复初始化
      if (this.isMapInitialized) {
        return;
      }
      this.shouldRenderMap = true;
      this.hasVisitedMapTab = true;
      this.isMapInitialized = true;

      // 等待地图组件渲染后设置位置
      this.$nextTick(function () {
        setTimeout(function () {
          if (_this27.locationInfo && _this27.locationInfo.lat && _this27.locationInfo.lng) {
            _this27.mapLocation = {
              lat: parseFloat(_this27.locationInfo.lat),
              lng: parseFloat(_this27.locationInfo.lng),
              address: _this27.locationInfo.addr || _this27.formValidate.address
            };
          }
        }, 300);
      });
    }
  }
};